var React = require('react');

function IcoFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.2948 7.41523C14.2948 3.47595 11.1206 0.283203 7.20654 0.283203C3.29245 0.283203 0.120117 3.47595 0.120117 7.41523C0.120117 10.9617 2.69313 13.8938 6.06154 14.4467V9.52077H4.26358V7.46363H6.06154V5.74904C6.06154 3.97674 7.24538 3.06266 8.83432 3.06639C9.30786 3.06639 10.0792 3.17436 10.3659 3.22649L10.353 4.98948H9.35781C8.64935 4.98948 8.28865 5.50144 8.28865 6.04691V7.46363H10.2827L9.94973 9.52077H8.28865V14.4579C11.6885 13.931 14.2948 10.984 14.2948 7.41523Z","fill":"black"}));
}

IcoFacebookInline.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = IcoFacebookInline;

IcoFacebookInline.default = IcoFacebookInline;
